import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { matchPath } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { isEmpty } from "lodash";

import CommTabs from "./CommTabs";
import Loading from "components/Loading";
import { CommunityRestricted } from "features/Navigation/PageNotFound";

import { selectCodeLib, selectUserUid } from "store/users/selectors";
import { selectCommunityId, selectCommunityLoading } from "store/community/selectors";
import { actions as userActions } from "store/users";
import { fetchCommunity, watchCommunityUpdates } from "store/community/thunk";
import { cleanUpCommunity } from "store/community/actions";

import classes from "./style.module.scss";

const { fetchUserCodeLib } = userActions;

const Community = ({
    loading,
    communityId,
    history,
    fetchCommunityData,
    fetchUserCodeLib,
    uid,
    codeLib,
    watchCommunityUpdates,
    cleanUpCommunity,
    // CHBA_NZ_ADMIN = false, //?
    // VOLTA_DEV = false //?
}) => {
    const pathCallback = useCallback(() => {
        return history.location.pathname;
    }, [history.location]);

    useEffect(() => {
        if (!communityId) {
            fetchCommunityData();
        }
    }, [communityId, fetchCommunityData]);

    useEffect(() => {
        if (isEmpty(codeLib)) {
            fetchUserCodeLib(uid);
        }
    }, [codeLib, uid, fetchUserCodeLib]);

    useEffect(() => {
        if (!communityId) return;

        const unsubscribe = watchCommunityUpdates(communityId);

        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [communityId]);

    useEffect(() => {
        return () => {
            cleanUpCommunity();
        };
    }, []);

    if (loading) {
        return <Loading className={classes.spinner} />;
    }

    if (!loading && !communityId) {
        return <CommunityRestricted />;
    }

    return (
        <div>
            <CommTabs uid={uid} communityId={communityId} history={history} pathCallback={pathCallback} />
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    uid: selectUserUid,
    communityId: selectCommunityId,
    loading: selectCommunityLoading,
    codeLib: selectCodeLib,
});

const mapDispatchToProps = (
    dispatch,
    {
        history: {
            location: { pathname },
        },
    }
) => ({
    fetchCommunityData: async () => {
        const { params: { communityId } = {} } =
            matchPath(pathname, {
                path: "/communities/:communityId",
            }) || {};

        if (communityId) {
            return dispatch(fetchCommunity(communityId));
        }
    },
    fetchUserCodeLib: (uid) => dispatch(fetchUserCodeLib(uid)),
    watchCommunityUpdates: (communityId) => dispatch(watchCommunityUpdates(communityId)),
    cleanUpCommunity: () => dispatch(cleanUpCommunity()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Community);
